module.exports = __webpack_public_path__ + "img/ganziqi.368fed61.jpg";